import { runGetLocation } from '../lib/funnels/functions/v1/default/runGetLocation'
import { setUpFormInputs } from '../lib/funnels/functions/v1/html/setupFormInputs'

runGetLocation('tdMainFunnel')

document.addEventListener('DOMContentLoaded', () => {
  setUpFormInputs()
})
